export default "__VITE_ASSET__DBbNwS8i__"